export const categories = [
  { id: 'all', name: '全部', icon: 'ri-apps-line' },
  { id: 'movie', name: '电影', icon: 'ri-film-line' },
  { id: 'tv', name: '电视剧', icon: 'ri-tv-line' },
  { id: 'variety', name: '综艺', icon: 'ri-emotion-laugh-line' },
  { id: 'anime', name: '动漫', icon: 'ri-rocket-line' },
  { id: 'documentary', name: '纪录片', icon: 'ri-earth-line' },
  { id: 'short', name: '短视频', icon: 'ri-vidicon-line' },
  { id: 'music', name: '音乐', icon: 'ri-music-line' },
  { id: 'sports', name: '体育', icon: 'ri-basketball-line' },
];

export const hotVideos = [
  {
    id: 1,
    title: '《流浪地球3》震撼来袭，国产科幻再攀高峰',
    category: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20scene%20with%20futuristic%20space%20station%20and%20glowing%20nebula%20in%20deep%20space%2C%20dramatic%20lighting%20with%20warm%20orange%20and%20gold%20tones%2C%20epic%20cinematic%20composition%2C%20clean%20simple%20dark%20background%20with%20stars%2C%20professional%20film%20poster%20style&width=640&height=360&seq=video-cover-01&orientation=landscape',
    views: '2.8亿',
    rating: 9.3,
    duration: '02:28:15',
    isNew: true,
    isHot: true,
  },
  {
    id: 2,
    title: '《乘风破浪的姐姐》第四季，全新阵容引爆话题',
    category: 'variety',
    cover: 'https://readdy.ai/api/search-image?query=Elegant%20variety%20show%20stage%20with%20shimmering%20golden%20and%20rose%20spotlights%2C%20glamorous%20performance%20stage%20with%20stunning%20lighting%20effects%2C%20warm%20atmospheric%20glow%2C%20clean%20dark%20background%2C%20entertainment%20show%20visual%20style&width=640&height=360&seq=video-cover-02&orientation=landscape',
    views: '1.5亿',
    rating: 8.9,
    duration: '01:55:30',
    isNew: true,
    isHot: true,
  },
  {
    id: 3,
    title: '《长安三万里》续集：大唐风华再现银幕',
    category: 'anime',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20animated%20scene%20with%20golden%20palace%20and%20cherry%20blossoms%20under%20warm%20sunset%20light%2C%20traditional%20Chinese%20architecture%20with%20soft%20golden%20and%20amber%20tones%2C%20cinematic%20animation%20style%2C%20simple%20warm%20background&width=640&height=360&seq=video-cover-03&orientation=landscape',
    views: '9.8亿',
    rating: 9.5,
    duration: '02:48:00',
    isNew: false,
    isHot: true,
  },
  {
    id: 4,
    title: '《奔跑吧》第十二季，全新游戏挑战升级',
    category: 'variety',
    cover: 'https://readdy.ai/api/search-image?query=Outdoor%20adventure%20game%20show%20scene%20with%20vibrant%20colorful%20obstacle%20course%20under%20bright%20sunlight%2C%20energetic%20summer%20atmosphere%20with%20warm%20golden%20hour%20lighting%2C%20clean%20natural%20background%2C%20entertainment%20show%20style&width=640&height=360&seq=video-cover-04&orientation=landscape',
    views: '3.2亿',
    rating: 8.7,
    duration: '02:05:00',
    isNew: true,
    isHot: false,
  },
  {
    id: 5,
    title: '《舌尖上的中国》第五季：寻味中华美食之旅',
    category: 'documentary',
    cover: 'https://readdy.ai/api/search-image?query=Close-up%20of%20steaming%20Chinese%20cuisine%20with%20golden%20warm%20lighting%2C%20traditional%20Chinese%20food%20on%20wooden%20table%20with%20soft%20steam%20rising%2C%20rich%20amber%20and%20coral%20tones%2C%20clean%20simple%20dark%20background%2C%20food%20documentary%20style&width=640&height=360&seq=video-cover-05&orientation=landscape',
    views: '6.5亿',
    rating: 9.7,
    duration: '00:50:00',
    isNew: false,
    isHot: true,
  },
  {
    id: 6,
    title: '《中国好声音》2026：全新导师阵容亮相',
    category: 'music',
    cover: 'https://readdy.ai/api/search-image?query=Music%20competition%20stage%20with%20dramatic%20spotlight%20and%20golden%20confetti%20falling%2C%20professional%20concert%20lighting%20with%20warm%20amber%20and%20rose%20tones%2C%20clean%20dark%20stage%20background%2C%20singing%20show%20visual%20style&width=640&height=360&seq=video-cover-06&orientation=landscape',
    views: '4.1亿',
    rating: 8.8,
    duration: '02:10:00',
    isNew: true,
    isHot: true,
  },
  {
    id: 7,
    title: '《NBA赛季集锦》2025-2026全明星赛精彩回顾',
    category: 'sports',
    cover: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20action%20shot%20with%20dramatic%20arena%20lighting%20and%20warm%20golden%20court%20reflections%2C%20athletic%20dunk%20moment%20frozen%20in%20time%2C%20clean%20dark%20crowd%20background%2C%20sports%20broadcast%20style&width=640&height=360&seq=video-cover-07&orientation=landscape',
    views: '2.3亿',
    rating: 9.1,
    duration: '00:48:30',
    isNew: false,
    isHot: false,
  },
  {
    id: 8,
    title: '《孤注一掷2》：反诈题材再掀观影热潮',
    category: 'movie',
    cover: 'https://readdy.ai/api/search-image?query=Intense%20crime%20thriller%20movie%20scene%20with%20dramatic%20warm%20and%20dark%20contrast%20lighting%2C%20mysterious%20atmosphere%20with%20golden%20and%20deep%20red%20accents%2C%20clean%20dark%20cinematic%20background%2C%20professional%20film%20poster%20style&width=640&height=360&seq=video-cover-08&orientation=landscape',
    views: '5.7亿',
    rating: 9.0,
    duration: '02:15:00',
    isNew: true,
    isHot: true,
  },
];

export const latestUpdates = [
  {
    id: 1,
    title: '《清明上河图密码》今晚更新第28集',
    category: '电视剧',
    time: '10分钟前',
    tag: '热播',
  },
  {
    id: 2,
    title: '《脱口秀大会》第六季总决赛精彩上线',
    category: '综艺',
    time: '25分钟前',
    tag: '新番',
  },
  {
    id: 3,
    title: '《斗罗大陆》动画版最新话：海神岛篇开启',
    category: '动漫',
    time: '1小时前',
    tag: '更新',
  },
  {
    id: 4,
    title: '《隐秘的角落2》正式定档，原班人马回归',
    category: '电视剧',
    time: '2小时前',
    tag: '预告',
  },
  {
    id: 5,
    title: '《极限挑战》第十季首播：全新挑战模式',
    category: '综艺',
    time: '3小时前',
    tag: '首播',
  },
  {
    id: 6,
    title: '《大秦帝国》系列纪录片完整上线',
    category: '纪录片',
    time: '5小时前',
    tag: '推荐',
  },
  {
    id: 7,
    title: '《黑神话：悟空》幕后制作特辑独家发布',
    category: '短视频',
    time: '6小时前',
    tag: '独家',
  },
  {
    id: 8,
    title: '《中国诗词大会》第九季精彩回顾合集',
    category: '综艺',
    time: '8小时前',
    tag: '回顾',
  },
];

export const features = [
  {
    id: 1,
    title: '海量高清资源',
    description: '汇聚数十万部影视综艺内容，1080P超清画质，杜比音效，沉浸式观影体验。',
    icon: 'ri-4k-line',
  },
  {
    id: 2,
    title: '完全免费观看',
    description: '所有视频资源永久免费，无需会员，无需付费，随时随地畅享精彩内容。',
    icon: 'ri-vip-crown-line',
  },
  {
    id: 3,
    title: '无需下载安装',
    description: '支持网页直接播放，不占手机存储空间，即点即看，流畅不卡顿。',
    icon: 'ri-cloud-line',
  },
  {
    id: 4,
    title: '多端同步观看',
    description: '支持手机、平板、电脑多设备无缝切换，观看记录云端同步，随时随地继续观看。',
    icon: 'ri-smartphone-line',
  },
  {
    id: 5,
    title: '智能推荐算法',
    description: '基于观影偏好智能匹配推荐内容，发现更多你可能喜欢的精彩视频。',
    icon: 'ri-bard-line',
  },
  {
    id: 6,
    title: '极速加载播放',
    description: '自建CDN加速网络，全国节点覆盖，视频秒加载，告别缓冲等待。',
    icon: 'ri-flashlight-line',
  },
];

export const testimonials = [
  {
    id: 1,
    name: '张先生',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%20with%20warm%20lighting%2C%20friendly%20expression%2C%20clean%20simple%20warm%20beige%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    comment: '用了91在线观看好几年了，资源特别全，更新也快。尤其是综艺节目基本同步更新，画质也非常清晰，强烈推荐！',
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '李女士',
    avatar: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20woman%20portrait%20with%20warm%20natural%20light%2C%20gentle%20smile%2C%20clean%20simple%20warm%20cream%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    comment: '最喜欢的就是不用下载APP，直接在浏览器就能看，手机电脑都能用，特别方便。内容也丰富，纪录片资源尤其赞！',
    date: '2026-07-25',
  },
  {
    id: 3,
    name: '王同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20with%20warm%20lighting%2C%20bright%20confident%20expression%2C%20clean%20simple%20warm%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 5,
    comment: '动漫资源太全了！国漫日漫都有，而且更新速度比其他平台快。免费高清简直良心，已经推荐给全班同学了。',
    date: '2026-07-22',
  },
];

export const stats = [
  { id: 1, value: '5000万+', label: '月活跃用户' },
  { id: 2, value: '30万+', label: '视频资源库' },
  { id: 3, value: '99.9%', label: '播放成功率' },
  { id: 4, value: '200+', label: '全球CDN节点' },
];